/**
 * Brand constants derived from environment variables.
 *
 * REACT_APP_COMPANY_NAME  – display name used in titles, print footers, fallback labels.
 * REACT_APP_PARENT_ORG    – the org identifier that enables parent-company-only features.
 *                           Matched against the `organization_name` stored in sessionStorage
 *                           after login.
 */

export const COMPANY_NAME: string =
  process.env.REACT_APP_COMPANY_NAME || "iMetanic";

export const PARENT_ORG: string =
  process.env.REACT_APP_PARENT_ORG || "iMetanic";

/**
 * Returns true when the currently logged-in organisation is the parent company.
 * Use this to gate features that should only be visible to the platform owner.
 *
 * @example
 * if (isParentOrg()) { ... show super-admin routes ... }
 */
export const isParentOrg = (): boolean =>
  sessionStorage.getItem("organization_name") === PARENT_ORG;

/**
 * Builds a browser tab title in the format "Page Name › iMetanic".
 *
 * @example
 * document.title = pageTitle("Orders");  // "Orders › iMetanic"
 */
export const pageTitle = (title: string): string => `${title} › ${COMPANY_NAME}`;
